import React from 'react'
import MessageCourse from './course'
import MessageUser from './user'
import useClientLocation from '../../../hooks/use-client-location'
import ErrorModal from '../../modals/error'

const MessageUserScreen = () => {
    const { queryParams, params, goBack } = useClientLocation()
    const subject = queryParams.get('subject')
    const userId = queryParams.get('userId')
    const courseId = queryParams.get('courseId')

    if (courseId) {
        return (
            <MessageCourse
                subject={subject}
                targetId={courseId}
                onHide={goBack}
            />
        )
    }

    if (userId) {
        return (
            <MessageUser
                subject={subject}
                targetId={userId}
                onHide={goBack}
            />
        )
    }

    return (
        <ErrorModal
            onHide={goBack}
        >
            No message information present
        </ErrorModal>
    )
}

export default MessageUserScreen